import { maybeConvertAmount } from '../../functions/currency';

/**
 * Facebook (Meta) Pixel events for the upsell flow.
 *
 * An accepted upsell fires an incremental Purchase carrying only the upsell's
 * own value — Meta sums Purchase values, so the initial checkout Purchase plus
 * this one add up to the full order value. The eventID must be the upsell line
 * item id: reusing the checkout id would collide with the initial Purchase and
 * Meta would silently discard this event as a duplicate.
 */

const isTrackingDisabled = () => !window?.fbq || window?.scData?.tracking?.facebook === false;

window.addEventListener('scUpsellAccepted', function (e) {
  if (isTrackingDisabled()) return;

  const { checkout, line_item: lineItem, product } = e.detail;

  window.fbq(
    'track',
    'Purchase',
    {
      content_ids: [product?.id],
      content_name: 'Purchase',
      content_type: 'product',
      contents: [{ id: product?.id, quantity: lineItem?.quantity || 1 }],
      currency: checkout?.currency,
      num_items: 1,
      value: maybeConvertAmount(lineItem?.total_amount || 0, checkout?.currency || 'USD'),
    },
    { eventID: lineItem?.id },
  );
});
